var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M61.7,17.1c-0.7-2.7-2.8-4.8-5.5-5.5C51.4,10.3,32,10.3,32,10.3s-19.4,0-24.2,1.3c-2.7,0.7-4.8,2.8-5.5,5.5C1,22,1,32,1,32\ts0,10.1,1.3,14.9c0.7,2.7,2.8,4.8,5.5,5.5c4.8,1.3,24.2,1.3,24.2,1.3s19.4,0,24.2-1.3c2.7-0.7,4.8-2.8,5.5-5.5C63,42.1,63,32,63,32\tS63,22,61.7,17.1z M25.8,41.3V22.7L41.9,32L25.8,41.3z"}));
}

Youtube.defaultProps = {"version":"1.1","viewBox":"0 0 64 64","x":"0","y":"0","xmlSpace":"preserve"};

module.exports = Youtube;

Youtube.default = Youtube;
